export function clearUserSession() {
    // Remove all session related stored data
    sessionStorage.removeItem("session_token");
    sessionStorage.removeItem("user_name");
    sessionStorage.removeItem("user_tenant_name");
    sessionStorage.removeItem("user_site_name");
}

export function validateSession() {
    // Check if user has logged in
    const userName = sessionStorage.getItem("user_name");
    const sessionToken = sessionStorage.getItem("session_token");
    // return true if both userName and sessionToken are found
    return !!(userName && sessionToken);
}

export function formatHeader(header: string) {
    /**
     * Basic helper function to convert underscore headers
     */

    if (!header) return "";
  
    // Replace underscores with spaces
    const withoutUnderscores = header.replace(/_/g, " ");
  
    // Uppercase first letter
    return withoutUnderscores.charAt(0).toUpperCase() + withoutUnderscores.slice(1);
}